import React from 'react';
import { connect } from 'react-redux';
import { StepAction } from 'Components/buttons/stepButton';
import { StepButton } from 'Components/buttons';

interface Props {
  stepProgression?: boolean;
  onKeyDown?: string;
  onAction?: (stepAction: StepAction) => void;
  classes?: any;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
  children: any;
}

const Button: React.FC<Props> = (props: Props) => {
  const { onAction, stepProgression } = props;
  return (
    <StepButton
      {...props}
      disabled={!stepProgression}
      onAction={stepProgression ? onAction : null}
    />
  );
};

Button.defaultProps = {
  stepProgression: true,
  onKeyDown: 'Enter',
  onAction: () => {},
  classes: {},
  disabled: false,
  type: 'button',
};

function mapStateToProps(state: any) {
  return {
    stepProgression: state.stepProgression,
  };
}

export default connect(mapStateToProps)(Button);
try {
    // @ts-ignore
    stepButton.displayName = "stepButton";
    // @ts-ignore
    stepButton.__docgenInfo = { "description": "", "displayName": "stepButton", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepButton/stepButton.tsx#stepButton"] = { docgenInfo: stepButton.__docgenInfo, name: "stepButton", path: "src/containers/stepButton/stepButton.tsx#stepButton" };
}
catch (__react_docgen_typescript_loader_error) { }